<template>
    <div class="report" style="height: calc(100% - 40px);">
      <div class="mainHead">
        <div class="route">
          <span class="crumbs"></span><span>设备列表</span>
        </div>
        <div> 
          <el-button type="primary" @click="Query" >查询</el-button>
          <el-button type="primary" @click="Printing" >导出</el-button>
        </div>
      </div>
      <div class="fixedScorll" :style="{height: heightCard + 'px'}">
        <div class="maindetails">
          <!-- <div>
            <div class="detailsName"> 
              <div class="condi_name">时间:</div>
                <div class="condi_scope">
                    <ul>
                        <li :class="{'scope_select': index == radio}" v-for="(item,index) in scopeStatus" :key="index" @click="scopeClick(index)">{{item.name}}</li>
                    </ul>
                    <div v-show="select1">
    <el-date-picker
      v-model="parms.start"
      type="datetime"
      placeholder="开始时间">
    </el-date-picker>
        ~
    <el-date-picker
      v-model="parms.end"
      type="datetime"
      placeholder="结束时间">
    </el-date-picker>
                    </div>
                </div>
            </div>
          </div> -->
          <div class="detailAddress">
              <div class="condi_name">设备类型:</div>
              <div>
                <el-checkbox-group v-model="parms.type">
                    <el-checkbox v-for="item in cities" :label="item.type" :key="item.type">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
          </div>
                    <div class="detailAddress">
              <div class="condi_name">监测状态:</div>
              <div>
                <el-checkbox-group v-model="parms.runStatus">
                    <el-checkbox v-for="item in cities2" :label="item.value" :key="item.value">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
          </div>
                    <div class="detailAddress">
              <div class="condi_name">通讯状态:</div>
              <div>
                <el-checkbox-group v-model="parms.connectStatus">
                    <el-checkbox v-for="item in cities3" :label="item.value" :key="item.value">{{item.name}}</el-checkbox>
                </el-checkbox-group>
              </div>
          </div>
        </div>
        <div class="mainList" id="mainList">
            <!-- <div class="survey">
                <div class="mainListhad"><em></em><span>总体概况</span></div>
                <div class="mainListcot">
                    <div><span>项目名称:</span> <span>{{detail.customerName}}</span></div>
                    <div><span>项目地址:</span> <span>{{detail.address}}</span></div>
                    <div><span>日期范围:</span> <span>{{detail.date}}</span></div>
                    <div><span>安全主任:</span> <span>{{detail.userName}}</span></div>
                    <div><span>联系电话:</span> <span>{{detail.userPhone}}</span></div>
                    <div><span>监测类型:</span> <span>{{detail.monitoringType}}</span></div>
                    <div><span>统计结果：</span> <span v-if="detail.monitorTotal>0">共监测<span style="color: #f55353">{{detail.monitorTotal}}</span>个监测点(预警<span style="color: #f55353">{{detail.waringCnt}}</span>个,告警<span style="color: #f55353">{{detail.alarmCnt}}</span>个,正常<span style="color: #f55353">{{detail.normalCnt}}</span>个)，预警<span style="color: #f55353">{{detail.monitorWaringTotal}}</span>次，告警<span style="color: #f55353">{{detail.monitorAlarmTotal}}</span>次。</span></div>
                </div>
            </div> -->
            <div class="result" :style="{height: heightBg + 'px'}">
                <div class="mainListhad">
                  <em></em> <span>设备详情</span>   
                </div>
                <div class="mainListContain clearfix">
                   <div class="monitor_table table_data">
                        <div>
                        <el-table :data="tableData" style="width: 100%" border max-height='465'>
                            <el-table-column type="index" label="序号" width="70"></el-table-column>
                            <el-table-column label="监测点名称" min-width="220" prop="monitoringName"  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="监测点编号" min-width="220" prop="monitoringCode"  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="监测点地址" min-width="318" prop="detailAddress"  show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column label="监测类型" prop="type"  min-width="146">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.type==1">电气</div>
                                    <div v-else-if="scope.row.type==2">水压</div>
                                    <div v-else-if="scope.row.type==3">液位</div>
                                    <div v-else-if="scope.row.type==4">可燃气</div>
                                    <div v-else-if="scope.row.type==5">烟感</div>
                                    <div v-else-if="scope.row.type==6">灭火器</div>
                                    <div v-else-if="scope.row.type==7">水浸</div>
                                    <div v-else-if="scope.row.type==8">用传</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="connectStatus" label="通讯状态" min-width="120">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.connectStatus==0">在线</div>
                                                <div v-else-if="scope.row.connectStatus==1">离线</div>
                                            </template>
                            </el-table-column>
                            <el-table-column prop="runStatus" label="监测状态" min-width="120">
                                            <template slot-scope="scope">
                                                <div v-if="scope.row.runStatus==1" style="color: #f55353">告警</div>
                                                <div v-else-if="scope.row.runStatus==2" style="color: #f55353">预警</div>
                                                <div v-else>正常</div>
                                            </template>
                            </el-table-column>
                            <el-table-column prop="recordTime" label="记录时间" min-width="220"></el-table-column>
                        </el-table>
                        </div>
                        <!-- <div style="text-align: right;margin-top: 15px"> 
                            <el-pagination @size-change="handleSizeChange1"  @current-change="handleCurrentChange1" :current-page.sync="currPage" :page-size="10" layout="prev, pager, next" :total='statusNum1' background></el-pagination>
                        </div> -->
                    </div>
                </div>
            </div>
            </div>
      </div>
            <!-- 提示框(自动消失) -->
    <el-dialog title="提示" class="tips" :visible.sync="dialogTipsVisible" :modal="false" @open="openDialog">
        <span>{{tips}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button style="min-width:80px" type="primary" @click="dialogTipsVisible = false">我知道了</el-button>
        </span>
    </el-dialog>
    </div>
</template>
<script>
    import {ajaxFuncJson} from '@/api/ajax';
    export default {
        name: 'Report',
        data() {
            return {
                /* start  */
        startTimeRule: {
          disabledDate: time => {
            if (this.endTime) {
              return (
                // time.getTime() > new Date(this.endTime).getTime()
                new Date(this.startTime).getTime() < new Date(this.endTime).getTime()
              );
            } else {
              // return time.getTime() > Date.now();
            }
          }
        },
        endTimeRule: {
          disabledDate: time => {
            if (this.startTime) {
              return (
                // time.getTime() > Date.now() ||
                // time.getTime() < new Date(this.startTime).getTime()
                new Date(this.startTime).getTime() < new Date(this.endTime).getTime()
              );
            } else {
              // return time.getTime() > Date.now();
            }
          }
        },
        /* end*/
                heightCard:'',
                heightBg:'',
                scopeStatus: [
                    {name: '日报'},
                    {name: '月报'},
                    {name: '季报'},
                    {name: '年报'},
                    {name: '自定义'}
                ],
                radio:'',
                cities:[],
                cities2:[{name:'告警',value:1},{name:'预警',value:2},{name:'正常',value:0}],
                cities3:[{name:'离线',value:1},{name:'在线',value:0}],
                detail:{},
                tableData:[],
                select1: false,
                customData: '',
                parms:{
                  type:[],
                  runStatus:[],
                  connectStatus:[],
                },
                windowResize:null,
                dialogTipsVisible: false,
                tips:'查询条件不满足,请选择"时间、类型"再查询！', //提示语
                statusNum1: 0,  //分页总条数
                currPage: 1,           //当前页数
                pageSize: 10           //数量

            }
        },
        computed:{
          getMap() {
            return this.$store.state.buildingId
          },
          navTopMsg(){
            return this.$store.state.navTopMsg
          }
        },
        watch: {
          navTopMsg(val){ //报警实时推送
            // this.Query();//推送更新
          },
          getMap (val) { // 左侧导航status的变化，然后执行操作
              this.getType();//获取报告类型
              this.parms.type =[];
              this.detail={};
              this.tableData=[];
              this.scopeClick(0);
              // this.parms.showTime = 'day';
              this.parms={
                  type:[],
                  runStatus:[],
                  connectStatus:[],
                }
             this.getDetails();

          }
        },
        created() {
          this.getType();//获取报告类型
          this.getDetails()
        },
        methods: {
          scopeClick(ind) {
              this.radio = ind;
              if(ind == 4) {
                  this.select1 = true;
                  this.parms.showTime = 'customize';
              } else {
                  this.select1 = false;
                  // this.customData="";
                    this.parms.start = '';
                    this.parms.end ='';
                  if(ind == 0) {
                      this.parms.showTime = 'day';
                  } else if(ind == 1) {
                      this.parms.showTime = 'month';
                  } else if(ind == 2) {
                      this.parms.showTime = 'season';
                  }else if(ind == 3) {
                      this.parms.showTime = 'year';
                  }
              }
          },
          Query(){

                      this.getDetails();//列表
          },
          Printing(){
            if(this.detail.monitorTotal=='0'){
                this.dialogTipsVisible = true;
                this.tips = '未查询到导出信息，请重新设置查询条件！'
            }else{
                  let jsonData = [];
                  this.tableData.forEach((a,b)=>{
                        if(a.type == 1) {
                            var types = '电气';
                        } else if(a.type == 2) {
                            var types = '水压';
                        } else if(a.type == 3) {
                            var types = '液位';
                        } else if(a.type == 4) {
                            var types = '可燃气';
                        } else if(a.type == 5) {
                           var types = '烟感';
                        } else if(a.type == 6) {
                            var types ='灭火器';
                        }else if(a.type == 7) {
                            var types = '水浸';
                        }else if(a.type == 8) {
                           var types = '用传';
                        }
                        if(a.connectStatus == 0){
                            var connectStatus = '在线'
                        }else if(a.connectStatus == 1){
                            var connectStatus = '离线'
                        }
                      if(a.runStatus == 0){
                            var runStatus = '正常'
                        }else if(a.runStatus == 1){
                            var runStatus = '告警'
                        }else if(a.runStatus == 2){
                            var runStatus = '预警'
                        }
                    jsonData.push(
                          {
                          index:b+1,
                          oneName:a.monitoringName,
                          two:a.monitoringCode,
                          three:a.detailAddress,
                          four:types,
                          five:connectStatus,
                          six:runStatus,
                          one:a.recordTime
                      }
                    )
                  })
                  // 列标题，逗号隔开，每一个逗号就是隔开一个单元格
                  let str = `智慧消防监测预警管理系统设备列表\n序号,监测点名称,监测点编号,监测点地址,监测类型,通讯状态,监测状态,记录时间\n`;
                  // 增加\t为了不让表格显示科学计数法或者其他格式
                  for(let i = 0 ; i < jsonData.length ; i++ ){
                      for(const key in jsonData[i]){
                          str+=`${jsonData[i][key] + '\t'},`;     
                      }
                      str+='\n';
                  }
                  str+='\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0\xa0导出时间:'+this.getNowTime()+'\n'
                  // encodeURIComponent解决中文乱码
                  const uri = 'data:text/csv;charset=utf-8,\ufeff' + encodeURIComponent(str);
                  // 通过创建a标签实现
                  const link = document.createElement("a");
                  link.href = uri;
                  // 对下载的文件命名
                  link.download =  "智慧消防监测预警管理系统设备列表.xls";
                  link.click();
            }
          },
        //分页按钮
        handleCurrentChange1(val){
            this.tableData = [];
            this.detailsListData.currPage = val;
            // this.dataDetailslist();
        },
        //分页按钮
        handleSizeChange1(val){
            this.tableData = [];
            this.detailsListData.currPage = val;
            // this.dataDetailslist();
        },
        getType(){
          let parms ={
            customerId:sessionStorage.getItem("customerId1"),
            buildingId:sessionStorage.getItem("analyBuildingId")
          }
          ajaxFuncJson('/analy/getAnalyType',parms).then(res=>{
              if(res.data.status == 200){
                  this.cities= res.data.data;
              }
          })
        },
        getDetails(){//分析报告
          let parms ={
            customerId:sessionStorage.getItem("customerId1"),
            buildingId:sessionStorage.getItem("analyBuildingId"),
            list:this.parms.type,
            runStatus:this.parms.runStatus,
            connectStatus:this.parms.connectStatus,
          }
          console.log(parms)
          ajaxFuncJson('/analy/getListMonitoringByData',parms).then(res=>{
              if(res.data.status == 200){
                //   this.detail= res.data.data.analysisMessageVO;
                  this.tableData= res.data.data;
                  this.isScroll();
              }
          })
        },
        getNowTime: function () {
          let dateTime
          let yy = new Date().getFullYear()
          let mm = new Date().getMonth() + 1
          let dd = new Date().getDate()
          let hh = new Date().getHours()
          let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes()
            :
            new Date().getMinutes()
          let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds()
            :
            new Date().getSeconds()
          dateTime = yy + '-' + mm + '-' + dd + ' ' + hh + ':' + mf + ':' + ss
          console.log(dateTime)
          return dateTime
        },
          openDialog() {
              setTimeout(() => {
                  this.dialogTipsVisible = false
              },6000)
          },
          initFont(){
            let that = this;
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true)-20;
                that.isScroll();
          },
          isScroll(){
            this.$nextTick(()=>{
              let sHeight=document.getElementsByClassName('fixedScorll')[0].scrollHeight,
                  cHeight=document.getElementsByClassName('fixedScorll')[0].clientHeight;
              if(sHeight>cHeight){
                  document.getElementsByClassName('maindetails')[0].style.marginRight=0;
                  document.getElementsByClassName('mainList')[0].style.marginRight=0;
              }else {
                document.getElementsByClassName('maindetails')[0].style.marginRight='1.05%';
                document.getElementsByClassName('mainList')[0].style.marginRight='1.05%';
              }
            });
          }
        },
        mounted() {
            let that = this;
            that.windowResize= function () {
                that.heightCard = $(document.body).height() - $('.el-header').outerHeight(true)- $('.mainHead').outerHeight(true) -20;
                that.heightBg =  that.heightCard -$('.maindetails').outerHeight(true)-20;
                that.isScroll();
            };
          that.windowResize();
          window.addEventListener('resize',that.windowResize);
        },
        destroyed(){
          let _this=this;
          window.removeEventListener("resize",_this.windowResize)
        }
    }
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    .el-main{  // 内容布局
        width: 78.1%;
        margin:10px 0 7px 1.05%;
        padding: 0;
    }
    .el-main  .maindetails{
        height: 191px;
        padding: 20px 50px;
        margin: 10px 0;
        margin-right: 1.05%;
        background-color: #fff;
        font-size: $fontSizeThree;
        color: #282828;
        &>div:first-child{
            @include flexible;
            .detailsName{
                @include flexible;
                @include alignItems(center);
                vertical-align: middle;
            }
        }
        .detailAddress{
            margin: 30px 0;
            @include flexible;
            @include alignItems(center);
            vertical-align: middle;
        }
    }
    .condi_name{
        margin-right: 10px;
    }
    .condi_scope {
            @include flexible;
            @include alignItems(center);
        li {
            margin-right: 10px;
            float: left;
            @include wh(60px,32px);
            padding: 0 10px;
            color: $TxteAllcolor;
            text-align: center;
            line-height: 32px;
            font-size: 13px;
            cursor: pointer;
            &:hover {
                background-color: #e5f2ff;
                color: $TxteAllcolor;
            }
        }
        .scope_select {
            color: #fff !important;
            background-color: #198cff !important;
        }
    }
    .mainList .survey{
        background-color: #fff;
        padding: 20px 0;
        .mainListcot{
            padding: 0 25px;
            &>div{
                margin-top: 10px;
                font-size: 14px;
                color: #282828;
            }
        }

    }
    .mainList .mainListhad{
        color: #000;
        font-size: 14px;
        font-weight: bold;
    }
   .mainList .result{
       margin-top: 10px;
        background-color: #fff;
        padding: 20px 0;
    .mainListContain{
            padding: 10px;

    }
    }
    em {
        display: inline-block;
        width: 6px;
        height: 16px;
        margin: 0 8px 0 10px;
        background-color: #198cff;
        vertical-align: -3px;
    }
</style>



// WEBPACK FOOTER //
// src/page/analysis/deviceList.vue